import { Col, Row } from "react-bootstrap";

import { Chapter } from "../../components/Chapter";
import React from "react";
import {
  useParams
} from "react-router-dom";

export const Wines = () => {

  let { nome } = useParams();
  React.useEffect(() => {
    if (nome) {
      const ele = document.getElementById(nome);
      const navHeight = window.innerHeight *0.15;
      window.scrollTo(ele.offsetLeft, ele.offsetTop-navHeight);
    }
  },)

  const chapters = [
    {
      name: "sialic",
      title: "Sialic: Profonde Radici tra le Rocce Sialitiche",
      text: "Il nostro Sialic è un vino bianco che nasce dal nostro vigneto omonimo di Sauvignon Blanc. Questo vino incarna la bellezza della semplicità naturale, le radici delle viti profondamente avvolte nelle roccie sialitiche sottostanti,  permettendo alle uve di esprimere appieno il terroir unico della nostra vigna. Le uve di Sauvignon Blanc vengono raccolte con cura e vinificate con vinificazione in bianco, mantenendo intatta la freschezza e la vitalità delle varietà. Il risultato è un vino che cattura la purezza delle uve e le note fruttate che caratterizzano il Sauvignon.<br>È un vino che celebra la bellezza della semplicità e la straordinaria complessità che può emergere da un approccio rispettoso verso l'uva e il terroir.<br>Ogni calice di Sialic è un viaggio nella freschezza e nell'autenticità, un'esperienza che celebra il carattere inconfondibile delle nostre vigne.",
      image: "/images/wines/sialic doc.png",
      buttons: [
        {
          link: "/sialic/20182019",
          bText: '2018-2019'
        },
        {
          link: "/sialic/2020",
          bText: '2020'
        },
        {
          link: "/sialic/2021",
          bText: '2021'
        }]
    },
    {
      name: "sialicesperienzadibotte",
      title: "Sialic Esperienza di Botte: Un Viaggio di Evoluzione",
      text: "Il Sialic Esperienza di Botte è una vera e propria interpretazione unica del nostro Sauvignon Blanc. In questo vino espressivo, sia la fermentazione che il successivo affinamento avvengono all'interno di una piccola botte di rovere. Questo processo consente al vino di riposare delicatamente sulle sue fecce in legno per circa un anno, acquisendo profondità e complessità uniche.<br>Durante questo periodo di affinamento, il vino intraprende un viaggio di trasformazione nel quale il legno aggiunge sfumature sottili ma significative ai suoi profumi e sapori. Questa esperienza enologica di botte dona al nostro Sauvignon Blanc un carattere unico, un equilibrio sorprendente tra freschezza fruttata e note leggermente vanigliate e tostate.",
      image: "/images/wines/sialic esperienza di botte.png",
      buttons: [{
        link: "/sialicesperienzadibotte/2020",
        bText: '2020'
      }]
    },
    {
      name: "sialicespressionidibucce",
      title: "Sialic Espressioni di Bucce: I Segreti Rivelati",
      text: "Il Sialic Espressioni di Bucce è una rielaborazione affascinante e audace del nostro Sauvignon Blanc. Le bucce dell'uva si uniscono al mosto in una breve e intensa danza, conferendo al mosto tutti i loro segreti di complessità aromatica e strutturale.<br>Questa fugace macerazione dona al futuro vino una profondità di carattere che lo distingue in modo eccezionale. I sapori e i profumi che emergono da questa macerazione sulle bucce sono sorprendenti, creando un vino che sfida le aspettative e incanta il palato. Il Sialic Espressione di Bucce è un'autentica esplorazione sensoriale, un'esperienza unica in ogni sorso.",
      image: "/images/wines/sialic espressioni di bucce.png",
      buttons: [{
        link: "/sialicespressionidibucce/2022",
        bText: '2022'
      }]
    },
    {
      name: "bram",
      title: "Bram: Eleganza Armonica dell'Internazionale e del Locale",
      text: "Il Bram è un meraviglioso connubio tra il vitigno internazionale Pinot Nero e la ricca cultura vinicola locale. Le uve, raccolte a perfetta maturità, vengono vinificate tramite il metodo a cappello sommerso, rivelando al vino sfumature fruttate, speziate e terrose che danzano in armonia con il carattere distintivo del terreno.<br>La nobiltà del vitigno si fonde con l'identità locale, integrandosi perfettamente e donando al vino tannini e colore. Il tempo è l'alleato che svela la vera essenza di questo vino. Dopo la vinificazione, il Bram affina per uno o due anni in piccole botti di legno e successivamente in vetro, consentendo al vino di raggiungere la sua massima espressione.<br>Ogni bottiglia racconta la storia dell'integrazione tra tradizione e innovazione, una testimonianza della passione e dell'attenzione che dedichiamo alla produzione dei nostri vini. Questo vino rivela il nostro impegno per offrire esperienze di degustazione indimenticabili. ",
      image: "/images/wines/bram doc.png",
      buttons: [
        {
          link: "/bramprimipassi/2020",
          bText: '2019'
        },
        {
          link: "/bram/2020",
          bText: '2020'
        },
        {
          link: "/bram/2021",
          bText: '2021'
        }]
    },
    {
      name: "brichet",
      title: "Brichet: Un Viaggio nel Tempo e nei Sapori",
      text: "Il nostro vino Brichet è risultato di un'abile miscela di diverse varietà di uve rosse e bianche, ognuna selezionata con cura per portare la sua unica personalità al vino. Questa combinazione di uve offre un bouquet di sapori freschi e avvincenti.<br>Testimonianza del nostro orgoglio e della nostra eredità vinicola, questo vino è la celebrazione di una vigna storica, dove la tradizione e l'innovazione si fondono in una sinfonia di sapori e aromi.<br>Ogni sorso di Brichet incarna l'essenza delle nostre terre e l'amore che investiamo in ogni bottiglia. Un viaggio nel tempo e nei sapori che ci connette alle nostre radici.",
      image: "/images/wines/brichet.png",
      buttons: [
        {
          link: "/brichet/19841995",
          bText: '1984-1995'
        },
        {
          link: "/brichet/2021",
          bText: '2021'
        },
       {
          link: "/brichet/2022",
          bText: '2022'
        }]
    },
    {
      name: "tan",
      title: "Tan: L'Arte della Terra Senza Compromessi",
      text: "Il Tan rappresenta l'essenza pura dell'arte vinicola locale. Questo vino è prodotto da un ampia varietà di vitigni appartenenti allo stesse vigneto, le uve sono raccolte con la massima cura e vinificate seguendo i metodi tradizionali tramandati da generazioni. Il vino non subisce chiarifiche e filtrazioni, ma decanta naturalmente sotto l'influsso del tempo e del clima durante il suo affinamento in botti lungo due anni. Questo approccio permette al vino di mantenere una struttura robusta e una complessità che rispecchiano il terroir incontaminato da cui proviene.<br>Con una degustazione che connette alle tradizioni vinicole secolari di questa regione, questo vino è un omaggio all'esperienza contadina, all'orgoglio della terra e all'amore per la viticoltura. Una ricetta vinicola autentica senza compromessi, un patrimonio che abbiamo l'onore di poter condividere.",
      image: "/images/wines/tan.png",
      buttons: [{
        link: "/tan/2020",
        bText: '2020'
      }]
    },
  ];

  return (
    <>
      <Row>
        <Col md={12} className="text-center">
          <h2>
          I Nostri Vini: Storie in Bottiglia di Passato, Presente e Futuro
          </h2>
        </Col>
      </Row>
      {chapters.map((chapter, index) => (
        <Chapter key={index} chapter={chapter} index={index} newPage= {false} />
      ))}
    </>
  );
};
